import axios from 'axios';
import { PROCESSING_EVENT_RESOURCE_TYPE } from '@/utils/processingEvent';

export default {
  state: {
    processingEventsByDocumentId: {},
    processingEventsBySearchQueryUuid: {},
  },
  getters: {
    getCachedProcessingEventsForDocumentId: (state) => (documentId) => {
      if (state.processingEventsByDocumentId[documentId]) {
        return state.processingEventsByDocumentId[documentId];
      }
      return null;
    },
    getCachedProcessingEventsForSearchQueryUuid: (state) => (queryUuid) => {
      if (state.processingEventsBySearchQueryUuid[queryUuid]) {
        return state.processingEventsBySearchQueryUuid[queryUuid];
      }
      return null;
    },
  },
  actions: {
    async fetchAndCacheProcessingEventsForDocumentId(context, { documentId }) {
      const response = await axios.get(
        `/api/v2/processing-events?resource_type=${PROCESSING_EVENT_RESOURCE_TYPE.DOCUMENT}&resource_id=${documentId}`,
      );
      const { data } = response;

      context.state.processingEventsByDocumentId[documentId] = data;

      return data;
    },
    async fetchAndCacheProcessingEventsForSearchQueryUuid(
      context,
      { queryUuid },
    ) {
      const response = await axios.get(
        `/api/v2/processing-events?resource_type=${PROCESSING_EVENT_RESOURCE_TYPE.SEARCH_QUERY}&resource_id=${queryUuid}`,
      );
      const { data } = response;

      context.state.processingEventsBySearchQueryUuid[queryUuid] = data;

      return data;
    },
  },
};
